import { Tag } from "antd";
import { SelectedProduct } from "routes/guide-details/guide-details";

interface DeviceTagProps {
	device: SelectedProduct;
	handleTagClose: (deviceId: string) => void;
}

const DeviceTag = ({ device, handleTagClose }: DeviceTagProps) => {
	return (
		<Tag
			closable
			onClose={e => {
				e.preventDefault();
				handleTagClose(device.id);
			}}
			className="device-tag"
			closeIcon={<img src={`${process.env.PUBLIC_URL}/assets/images/icons/x-circle.svg`} alt="Close" />}
		>
			<div className="device-tag-content">
				{device.photo_link && (
					<img
						src={device.photo_link}
						alt={device.name}
						className="device-tag-image"
						onError={e => {
							// Hide image if it fails to load
							(e.target as HTMLImageElement).style.display = "none";
						}}
					/>
				)}
				<span className="device-tag-label">{device.name}</span>
			</div>
		</Tag>
	);
};

export default DeviceTag;
